import React, { useEffect, useState } from "react";
import { Modal3 } from "../../../../../components/DIsplay/Modal/Modal3";
import Button1 from "../../../../../components/form/Button1";
import CommonFreeTextInput from "../../../../../components/common/inputs/CommonFreeTextInput";
import { enqueueSnackbar } from "notistack";
import CommonDropdownInput from "../../../../../components/common/inputs/CommonDropdownInput";

function EditPassengerDetail({
  open,
  setOpen,
  data: { onUpdateTicket, updatedTicket, flightBooking, bookingData, order },
}) {
  const [detail, setDetail] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    travelerType: "",
  });

  const GENDER_OPTIONS = ["Male", "Female"];
  const TRAVELER_TYPE_OPTIONS = [
    { code: "ADT", label: "Adult" },
    { code: "CHD", label: "Child" },
    { code: "INF", label: "Infant" },
  ];

  const isEmpty = (v) =>
    v === null || v === undefined || (typeof v === "string" && v.trim() === "");

  const REQUIRED_FIELDS = [
    { key: "firstName", label: "First name" },
    { key: "lastName", label: "Last name" },
    { key: "gender", label: "Gender" },
    { key: "travelerType", label: "Traveler type" },
  ];

  const firstMissingLabel = (obj) => {
    for (const f of REQUIRED_FIELDS) {
      if (isEmpty(obj[f.key])) return f.label;
    }
    return null;
  };

  const updateDetailOnOpen = () => {
    if (typeof open !== "string") return;
    const index = Number(open);
    const data = updatedTicket || flightBooking;
    const passenger = data?.travelers?.at(index);
    // const passenger = displayedTravelers?.at(index);
    if (passenger) {
      setDetail({
        firstName: passenger?.firstName || "",
        middleName: passenger?.middleName || "",
        lastName: passenger?.lastName || "",
        gender: passenger?.gender || "",
        travelerType: passenger?.travelerType || "",
      });
    }
  };

  useEffect(() => {
    updateDetailOnOpen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleSave = () => {
    const missing = firstMissingLabel(detail);
    if (missing) {
      enqueueSnackbar(`${missing} is required.`, { variant: "warning" });
      return;
    }

    if (typeof open !== "string") return;
    const index = Number(open);
    const data = updatedTicket || flightBooking;

    onUpdateTicket({
      ...data,
      travelers:
        data?.travelers?.map((traveler, travelerIndex) =>
          travelerIndex === index
            ? {
                ...traveler,
                firstName: detail.firstName,
                middleName: detail.middleName, // optional; keep as empty string if not provided
                lastName: detail.lastName,
                gender: detail.gender,
                travelerType: detail.travelerType,
              }
            : traveler
        ) || [],
    });

    setOpen(false);
  };

  return (
    <div>
      <Modal3 open={open} setOpen={setOpen} title="Edit Passenger">
        <div className="card p-6 flex flex-col gap-5 justify-start w-96 min-h-[60vh]">
          <CommonFreeTextInput
            value={detail.firstName}
            onChange={(val) => setDetail({ ...detail, firstName: val })}
            label="First Name"
            placeholder="e.g. John"
          />

          <CommonFreeTextInput
            value={detail.middleName}
            onChange={(val) => setDetail({ ...detail, middleName: val })}
            label="Middle Name (optional)"
            placeholder="e.g. Michael"
          />

          <CommonFreeTextInput
            value={detail.lastName}
            onChange={(val) => setDetail({ ...detail, lastName: val })}
            label="Last Name"
            placeholder="e.g. Doe"
          />

          <CommonDropdownInput
            label="Gender"
            value={detail.gender}
            onChange={(val) => setDetail({ ...detail, gender: val })}
            options={GENDER_OPTIONS}
            placeholder="Select gender"
            // CommonDropdownInput treats plain array values directly
          />

          <CommonDropdownInput
            label="Traveler Type"
            value={detail.travelerType}
            onChange={(code) => setDetail({ ...detail, travelerType: code })}
            options={TRAVELER_TYPE_OPTIONS}
            optionObject
            placeholder="Select traveler type"
            dropdownPosition="bottom-20"
          />

          <div className="flex gap-3 items-center justify-end">
            <Button1
              variant="outlined"
              className="whitespace-nowrap"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button1>
            <Button1 onClick={handleSave}>Save Draft</Button1>
          </div>
        </div>
      </Modal3>
    </div>
  );
}

export default EditPassengerDetail;
